import {Component, Input } from '@angular/core';
import { SideNavService } from '@valg-shared/services/sidenav.service'

export interface FooterLink {
  href: string;
  titleKey: string;
  isExternal?: boolean;
  newTab?: boolean;
}

@Component({
  selector: 'valg-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent {

  @Input() public leftPaneTitleKey = 'footer_title';
  @Input() public leftPaneContent: string[] = [];
  @Input() public links: FooterLink[] = [];
  @Input() public informationWidth: 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 = 6;
  public sidenavOpen: boolean = false;

  constructor(private sidenavService: SideNavService) {
    this.sidenavService.isOpen$.subscribe((isOpen: boolean) => {
      this.sidenavOpen = isOpen;
    });
  }
}